import type { IMilkingProcessDeviationResponse } from 'models/MilkingProcess'

/**
 * Mock для превью виджетов MilkingDeviations, DeviationsCarousel, DeviationsParallel.
 */
export const MILKING_PROCESS_DEVIATION_MOCK: IMilkingProcessDeviationResponse =
	{
		count: 3,
		next: null,
		previous: null,
		results: [],
	}
